// extracted by mini-css-extract-plugin
export default {"close":"index_close_nEpUb","num":"index_num_Ldc4G","current":"index_current_YYi45","total":"index_total_8f-QW"};